
// export const apiUrl ="http://localhost:5242/api/";
// export const apiAsset ="http://localhost:5242/uploads/";
export const apiUrl ="https://api.infinityapply.com/api/";
export const apiAsset ="https://api.infinityapply.com/uploads/";

